import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 8a8 8 0 1 1 8 8 8.01 8.01 0 0 1-8-8m2 0a6 6 0 1 0 12 0A6 6 0 0 0 2 8m4.293 2.707-2-2a1 1 0 0 1 1.414-1.413L7 8.586l3.293-3.292a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0z" }));
const ForwardRef = forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
